import { Wheel } from "spin-wheel";

import { spinTurns } from "./wheel_spin.mjs";

// The browser used to pick the winning slice with Math.random() and tell the server which
// one it was, which meant the player chose how much money they sent. The tap now only asks
// the server to spin; the server rolls, charges, and sends back the animation to play.
export default {
    mounted() {
        this.requested = false;
        this.initWheel();

        this.handleEvent("wheel:spin", ({ game_id, target_index, duration, rotations }) => {
            if (game_id !== this.el.dataset.gameId || !this.wheel) return;

            this.wheel.spinToItem(target_index, duration, true, spinTurns(rotations), 1);
        });

        // The tap dims the wheel before the server has answered, so a spin it refuses has to
        // hand it back or the player is left with a wheel that will not turn.
        this.handleEvent("wheel:spin_failed", ({ game_id }) => {
            if (game_id !== this.el.dataset.gameId) return;

            this.requested = false;
            this.el.style.cursor = "";
            this.el.style.opacity = "";
        });
    },

    updated() {
        if (!this.wheel) this.initWheel();
    },

    initWheel() {
        const canvas = this.el;

        if (!canvas) return;

        const sectionsData = JSON.parse(canvas.dataset.wheelSections || "[]");

        if (sectionsData.length === 0) return;

        const items = sectionsData.map((section) => ({
            label: `$${this.formatAmount(section.amount / 1000000)}`,
            backgroundColor: section.color,
            labelColor: this.getContrastColor(section.color),
            value: section.id,
        }));

        const props = {
            items: items,
            rotationResistance: -40,
            pointerAngle: 90,
            isInteractive: false,
            itemLabelFontSizeMax: 65,
            itemLabelAlign: "right",
            itemLabelRadius: 0.75,
        };

        this.wheel = new Wheel(canvas, props);

        // Purely a UI reveal -- the money moved when the server rolled, so a client that
        // never gets here cannot dodge the charge, and one that sends it twice cannot
        // repeat it.
        this.wheel.onRest = () => {
            this.pushEventTo(this.el, "spin_finished", {});
        };

        canvas.addEventListener("click", () => {
            if (this.requested) return;

            this.requested = true;
            canvas.style.cursor = "not-allowed";
            canvas.style.opacity = "0.6";

            this.pushEventTo(this.el, "spin", {});
        });
    },

    getContrastColor(hexColor) {
        const hex = hexColor.replace("#", "");
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);
        const brightness = (r * 299 + g * 587 + b * 114) / 1000;
        return brightness > 155 ? "#000000" : "#FFFFFF";
    },

    formatAmount(amount) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    destroyed() {
        if (this.wheel) {
            this.wheel.remove();
        }
    },
};
